import React, { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
// import { propTypes } from 'react-bootstrap/esm/Image';
import { useDispatch, useSelector } from "react-redux";
import { setDialog } from "../../store/api/GetAllProduct";
import { ExclamationTriangleFill as Alert, Check, DashCircleFill as Cancel, CheckLg } from "react-bootstrap-icons";
const ModalDialog = () => {
    const openDialog = useSelector(state => state.popup?.openDialog);
    const {arrayBtn, status, autoClose, okOperation} = openDialog;
    const dispatch = useDispatch();
    const handleModal = () => {
        if (okOperation) {
            {
                dispatch(okOperation);
            }
        }
        dispatch(setDialog({ status: 'hide' }));
    }
    useEffect(() => {
        console.log("hhh");
        if (autoClose) {
            setTimeout(() => {
                dispatch(setDialog({ status: 'hide' }));
            },autoClose)
        }
    }, [status])

    return (
        <Modal show={status === 'show'} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle' style={{ display: 'inline-block', color: 'white', padding: '0.6rem 0.6rem' }}><Alert size={22} style={{ color: 'rgb(255 178 4)' }} />&nbsp;&nbsp;{openDialog.dialogTitle}</Modal.Header>
            <Modal.Body>
                <span>{openDialog.dialogText}</span>
            </Modal.Body>
            <Modal.Footer style={{ justifyContent: "flex-start" }}>
                {arrayBtn && arrayBtn.includes("yes") && <Button variant='info' className="group-Btn"  onClick={handleModal}><CheckLg size={14} />&nbsp;&nbsp;بله&nbsp;</Button>}
                {arrayBtn && arrayBtn.includes("no") && <Button variant='danger' className="group-Btn"  onClick={() => dispatch(setDialog({ status: 'hide' }))}><Cancel size={15} /> &nbsp;خیر</Button>}
                {arrayBtn && arrayBtn.includes("ok") && <Button className='group-Btn' style={{ fontSize: "12px" }} onClick={() => handleModal()}>متوجه شدم</Button>}
            </Modal.Footer>
        </Modal>
    )
}
export default ModalDialog;